import { useCurrentConversationIdValue } from 'hooks/business/conversation';
import { useGetConversationById } from 'hooks/business/lruConversation';
import { Sticker, UserDB } from 'lib/db';
import { useLiveQuery } from 'dexie-react-hooks';
import { orderBy } from 'lodash-es';
import { getStickerRegion } from '.';

/**
 * 记录当前会话使用的表情包 id
 */
export const useRecordStickerToRecentUsed = () => {
  return async (stickerId: string) => {
    const preference = await UserDB.instance?.recentUsedSticker
      .where('id')
      .equals(stickerId)
      .first();
    await UserDB.instance?.recentUsedSticker.put(
      {
        used: (preference?.used ?? 0) + 1,
        id: stickerId,
      },
      stickerId,
    );
  };
};

/**
 * 获取当前会话最近使用的表情包列表
 */
export const useGetRecentUsedStickers = () => {
  const conversationId = useCurrentConversationIdValue();
  const getConversationById = useGetConversationById();

  const stickers = useLiveQuery<Sticker[], Sticker[]>(
    async () => {
      if (conversationId) {
        const conversation = getConversationById(conversationId);
        if (conversation) {
          const recentUsed = (await UserDB.instance?.recentUsedSticker.toArray()) ?? [];
          const recentUsedStickers = await Promise.all(
            orderBy(recentUsed, 'used', 'desc').map(
              async ({ id }) => await UserDB.instance?.sticker.where('id').equals(id).first(),
            ),
          );

          return recentUsedStickers.filter(
            (sticker) =>
              sticker &&
              sticker.channel === conversation.channel &&
              sticker.region === getStickerRegion(conversation.channel, conversation.region),
          ) as Sticker[];
        }
      }
      return [];
    },
    [conversationId, getConversationById],
    [],
  );

  return stickers;
};
